// @flow
import { post } from "./common";
import { handleAPIErrors } from '../sentry-util';

export const getLiveSkus = async(imei: string, mobile: string, affiliateUrl: string, session: string) => {
  try {
    const res = await post('/customer/app/liveproducts', {
      imei,
      mobile,
      affiliateUrl
    }, { session });

    const { status = false, data} = res;
    if (!status) {
      throw new Error('No products available');
    }
    return data;
  } catch (error) {
    handleAPIErrors(error, '/customer/app/liveproducts', 'POST', {
      imei,
      mobile
    });
    throw error
  }
}